import {
    ActionReducerMapBuilder,
    createSlice,
    PayloadAction,
} from '@reduxjs/toolkit';
import { authLogin, getMe } from '@api/thunks/auth';
import { RootState } from '@config/store';
import { ENotificationStatus } from '@utils';
import { sendNotification } from '@utils/functions';
import { IAuthState, IRespLogin, ITokens } from '../types';

const initialState: IAuthState = {
    token: null,
    user: null,
    shop: null,
    shops: [],
    message: '',
    isShowErrMess: false,
    loading: 'idle',
    error: null,
};

const authSlice = createSlice({
    name: '@@auth',
    initialState,
    reducers: {
        updateToken: (state: IAuthState, action: PayloadAction<ITokens>) => {
            state.token = action.payload.accessToken;
        },
        handleRemoveToken: (state: IAuthState) => {
            state.token = null;
            state.user = null;
            state.shop = null;
            state.shops = [];
        },

        setError: (state, { payload }: PayloadAction<string>) => {
            state.error = payload;
            sendNotification(payload, ENotificationStatus.ERROR, 'top-center');
        },
        handleSwitchShop: (
            state,
            { payload }: PayloadAction<{ id: number }>
        ) => {
            const selectedShop = state.shops.find(
                shop => shop.id === payload.id
            );
            if (selectedShop) {
                state.shop = selectedShop;
            }
        },
    },
    extraReducers: (builder: ActionReducerMapBuilder<IAuthState>) => {
        builder

            .addCase(
                authLogin.fulfilled,
                (state: IAuthState, { payload }: PayloadAction<IRespLogin>) => {
                    state.token = payload.token.accessToken;
                    state.user = payload.user;
                    state.shop = payload.shops[0];
                    state.shops = payload.shops;
                }
            )
            .addCase(
                getMe.fulfilled,
                (state: IAuthState, { payload }: PayloadAction<IRespLogin>) => {
                    state.token = payload.token.accessToken;
                    state.user = payload.user;
                    state.shop = payload.shops[0];
                    state.shops = payload.shops;
                }
            )

            .addMatcher(
                action => action.type.endsWith('/pending'),
                state => {
                    state.loading = 'loading';
                    state.error = null;
                }
            )
            .addMatcher(
                action => action.type.endsWith('/rejected'),
                state => {
                    state.loading = 'idle';
                    state.isShowErrMess = true;
                }
            )
            .addMatcher(
                action => action.type.endsWith('/fulfilled'),
                state => {
                    state.loading = 'idle';
                }
            );
    },
});

export const { handleRemoveToken, setError, handleSwitchShop } =
    authSlice.actions;
export const authReducer = authSlice.reducer;

export const authInfoSelect = (state: RootState) => state.auth;
